import { FC, ReactNode } from 'react';

import { Avatar, TimeAgo } from '../../../shared/ui';

type Props = {
  createdAt: Date;
  displayName: string;
  photoUrl: string;
  PermissionStatus?: ReactNode;
  Title: ReactNode;
};

export const VideoCardDescription: FC<Props> = ({
  createdAt,
  displayName,
  photoUrl,
  Title,
  PermissionStatus,
}) => {
  return (
    <div className="sm:px-5 flex flex-col gap-y-2">
      {Title}
      <div className="flex flex-nowrap gap-x-2 items-center text-gray-600 text-sm">
        <VideoCardStatus
          displayName={displayName}
          photoUrl={photoUrl}
          PermissionStatus={PermissionStatus}
        />
        <TimeAgo
          datetime={createdAt}
          locale="my"
          className="flex-shrink-0 ml-auto"
        />
      </div>
    </div>
  );
};

export const VideoCardStatus: FC<
  Pick<Props, 'displayName' | 'photoUrl' | 'PermissionStatus'>
> = ({ displayName, photoUrl, PermissionStatus }) => {
  return (
    <>
      <Avatar
        className="border border-base-black/[0.08] !text-xxs"
        isUserAvatar
        src={photoUrl}
        displayName={displayName}
        size="2xs"
      />
      <p className="truncate">{displayName}</p>
      {PermissionStatus && (
        <>
          <p>•</p>
          {PermissionStatus}
        </>
      )}
    </>
  );
};
